/**
 * URL para ficheiros em `public/` (respeita PUBLIC_URL em deploy com subpasta).
 * @param {string} path - ex. "/images/vips/bronze.webp"
 */
export function publicAsset(path) {
    const p = path.startsWith("/") ? path : `/${path}`;
    const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
    return base ? `${base}${p}` : p;
}
